import Marquee from "../marquee/marquee";
import Reveal from "../../common/Reveal";

const AboutSpirit = () => {

  return (
    <section id="about" className="relative w-full py-20 md:py-32 bg-[transparent] overflow-hidden scroll-mt-24">

      {/* Marquee */}
      <div className="mb-5">
        <Marquee text="WHAT IS SPIRIT?" speed={18}/>
      </div>

      {/* Content */}
      <Reveal className="relative z-10 max-w-[1200px] mx-auto text-center px-6">
        <p className="text-xl sm:text-2xl md:text-[36px] font-manrope font-black leading-relaxed md:leading-[2] text-[#65706E]">
          You've seen the excitement, the competition, and the crowd.
          <br />
          But have you ever wondered what it takes to bring an event of
          <br />
          this scale to life?{" "}
          <span
            className="
              inline-block
              px-5
              py-2
              mx-2
              border-[3px]
              border-[#CC5E15]
              text-black
              font-black
              font-shadow
              italic
              text-xl
              sm:text-2xl
              md:text-[36px]
              leading-none
              align-middle
              rounded-lg
              rotate-[-1deg]
            "
            style={{
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.4)",
            }}
          >
            Join the team behind SPIRIT
          </span>
          and experience
          <br />
          the festival from a whole new perspective.
        </p>
      </Reveal>
    </section>
  );
};

export default AboutSpirit;
